export const POST_ACTION_EDIT = 'edit'

export const POST_ACTION_BLOCK_ITEM = 'block_item'

export const POST_ACTION_UNBLOCK_ITEM = 'unblock_item'

export const POST_ACTION_BLOCK_USER = 'block_user'

export const POST_ACTION_UNBLOCK_USER = 'unblock_user'

export const POST_ACTION_ARCHIVE_ITEM = 'archive_item'

export const POST_ACTION_REPORT_USER = 'report_user'

export const POST_ACTION_REPORT_POST = 'report_post'

export const POST_ACTION_CONNECT_REQUEST = 'connect_request'

export const POST_ACTION_CREATE_REQUEST = 'create_request'
